module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/525c16734eee6d79996106a08d1cc5e8.png";